import * as React from 'react';
import { SVGProps } from 'react';

const SvgCloseOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <rect
      x={7.05}
      y={5.636}
      width={16}
      height={2}
      rx={1}
      transform="rotate(45 7.05 5.636)"
      fill="currentColor"
    />
    <rect
      x={5.636}
      y={16.95}
      width={16}
      height={2}
      rx={1}
      transform="rotate(-45 5.636 16.95)"
      fill="currentColor"
    />
  </svg>
);

export default SvgCloseOutlined;
